// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const EmailIcon = createSvgIcon(
  <svg width={24} height={24} fill="currentColor" viewBox="0 0 24 24">
    <path d="M5.28 5a3 3 0 0 0-2.9 3.03v7.94c0 1.66 1.3 3.03 2.9 3.03h13.44c1.6 0 2.9-1.36 2.9-3.03V8.03c0-1.66-1.3-3.03-2.9-3.03zm0 1.4h13.44q.35 0 .65.15l-7.16 7c-.08.08-.34.08-.42 0l-7.16-7q.3-.15.65-.15M3.77 7.62l4.94 4.84-4.88 4.13q-.1-.29-.11-.62V8.03q0-.2.05-.4m16.46 0q.05.2.05.41v7.94q0 .33-.11.62l-4.88-4.13zM9.7 13.42l1.18 1.15a1.6 1.6 0 0 0 2.26 0l1.18-1.14 4.84 4.11q-.2.06-.44.06H5.28q-.23 0-.43-.06z" />
  </svg>,
  "Email",
);
export default EmailIcon;
